
import { Component, Prop, Vue } from 'vue-property-decorator';
import { techniqueKey, TechniqueOption } from '@/content/schema';

/** Name of a used technique: one of the techniques used before, or a new one. */
@Component
export default class TechniqueField extends Vue {
  @Prop({ required: true }) readonly value!: string;
  @Prop({ required: true }) readonly label!: string;
  @Prop({ type: Array, default: () => [] }) readonly options!: TechniqueOption[];
  @Prop({ type: Array, default: () => [] }) readonly errorMessages!: string[];

  get names(): string[] {
    return this.options.map((option) => option.name).sort((a, b) => a.localeCompare(b, 'nl'));
  }

  /** A typed name that only differs in capitals, accents or spaces becomes the existing spelling. */
  onChange(next: unknown): void {
    const typed = typeof next === 'string' ? next.trim() : '';
    const existing = this.options.find((option) => techniqueKey(option.name) === techniqueKey(typed));
    this.$emit('input', existing ? existing.name : typed);
  }
}
